import { isDealerListing } from '@/domain/listings/isDealerListing'
import { type Listing } from '@/types/search'

export const getDealerIds = (listings: Listing[]) =>
  listings.reduce<(number | undefined)[]>((acc, listing) => {
    if (!isDealerListing(listing)) return acc
    const dealerId = listing.posterInfo?.id
    return acc.includes(dealerId) ? acc : [...acc, dealerId]
  }, [])
